<div
  *ngIf="canUpdateDetails"
  class="container mt-5">

  <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

  <div class="row mb-5">
    <div class="col-12">
      <h1 class="text-center">
        Your details
      </h1>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-12 mb-3">

      <form
        #userDetailsForm="ngForm"
        (ngSubmit)="save()"
        novalidate>

        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="line1">
                Address line 1
              </label>
              <input
                #line1="ngModel"
                class="form-control"
                [class.is-invalid]="line1.touched && !line1.valid"
                id="line1"
                name="line1"
                [(ngModel)]="mainAddress.line1"
                placeholder="Address line 1"
                required
                type="text">
              <div
                *ngIf="line1.invalid && line1.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
              <div class="mb-3">
              <label class="form-label" for="line2">
                Address line 2 (optional)
              </label>
              <input
                #line2="ngModel"
                class="form-control"
                [class.is-invalid]="line2.touched && !line2.valid"
                id="line2"
                name="line2"
                [(ngModel)]="mainAddress.line2"
                placeholder="Address line 2"
                type="text">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="city">
                Town/City
              </label>
              <input
                #city="ngModel"
                class="form-control"
                [class.is-invalid]="city.touched && !city.valid"
                id="city"
                name="city"
                [(ngModel)]="mainAddress.town"
                placeholder="Town/City"
                required
                type="text">
              <div
                *ngIf="city.invalid && city.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="postcode">
                Postcode
              </label>
              <input
                #postcode="ngModel"
                class="form-control"
                [class.is-invalid]="(postcode.touched && !postcode.valid)"
                id="postcode"
                name="postcode"
                [(ngModel)]="mainAddress.postcode"
                placeholder="Postcode"
                required
                type="text">
              <div
                *ngIf="postcode.errors && postcode.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="telephone">
                Phone number
              </label>
              <input
                #telephone="ngModel"
                class="form-control"
                [class.is-invalid]="telephone.touched && !telephone.valid"
                id="telephone"
                name="telephone"
                [(ngModel)]="user.contact.mainPhoneNumber"
                [pattern]="validationPatterns.telephone"
                placeholder="Phone number"
                required
                type="text">
              <div
                *ngIf="telephone.errors && telephone.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="telephone.errors && telephone.errors.pattern && !telephone.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.telephoneInvalid }}
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="telephone2">
                Second phone number (optional)
              </label>
              <input
                #telephone2="ngModel"
                class="form-control"
                [class.is-invalid]="telephone2.touched && !telephone2.valid"
                id="telephone2"
                name="telephone2"
                [(ngModel)]="user.contact.secondaryPhoneNumber"
                [pattern]="validationPatterns.telephone"
                placeholder="Second phone number"
                type="text">
              <div
                *ngIf="telephone2.errors && telephone2.errors.pattern && !telephone2.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.telephoneInvalid }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 offset-sm-3">
            <button
              type="submit"
              class="btn btn-success text-white btn-lg w-100 mt-5"
              [disabled]="!userDetailsForm.valid || loading">
              <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
              {{ loading ? 'Saving' : 'Next' }}
            </button>
          </div>
        </div>

      </form>

    </div>
  </div>

</div>
